import './media-selector.scss';

import { loadYoutubeApi } from '../../utilities/js/helper';

class MediaSelector {
    constructor (element) {
        this.$media = element;
        this.mediaType = this.$media.getAttribute('data-media');
        this.$video = null;
    }

    initialize () {
        if (this.mediaType === 'youtube') {
            this.$video = this.$media.querySelector('[data-youtube]');

            import('../../utilities/js/youtube-player').then(({ YoutubePlayer }) => {
                this.initYoutubePlayer(YoutubePlayer);
            });
        }

        if (this.mediaType === 'video') {
            this.$video = this.$media.querySelector('video');
            this.initHTML5Player();
        }
    }

    initYoutubePlayer (YoutubePlayer) {
        if (this.$video) {
            const youtubeId = this.$video.getAttribute('data-youtube');
            const $playButton = this.$media.querySelector('[data-media="play"]');
            let buttonActiveState = true;

            if (youtubeId !== '') {
                const videoPlayer = new YoutubePlayer(this.$video, {
                    silent: !!this.$video.getAttribute('data-muted'),
                    autoplay: !!this.$video.getAttribute('data-autoplay'),
                    fullscreen: !!this.$video.getAttribute('data-fullscreen'),
                    loop: !!this.$video.getAttribute('data-loop'),
                    root: this.$media,
                    id: youtubeId,
                    observe: true,
                    onCall: () => {
                        this.$media.classList.add('is--shown');
                    },
                    onStart: (videoId) => {
                        this.$media.classList.add('is--shown');
                    },
                    onEnd: (videoId) => {
                        if (videoPlayer.player.video.isMuted() === false) {
                            videoPlayer.destroy();
                            this.$media.classList.remove('is--shown');
                            buttonActiveState = true;
                        }
                    },
                    onPause: (videoId, progress) => {
                        console.log('video pause');
                    }
                });

                $playButton.addEventListener('keydown', (e) => {
                    if (buttonActiveState === true) {
                        buttonActiveState = false;

                        const interval = setInterval(() => {
                            const $iframe = this.$video.parentElement.querySelector('iframe');
                            if ($iframe) {
                                $iframe.setAttribute('tabindex', '0');
                                $iframe.focus();
                                clearInterval(interval);
                            }
                        }, 100);
                    }
                });
            }
        }
    }

    initHTML5Player () {
        const autoplay = (this.$video.getAttribute('autoplay') === '');
        const loop = (this.$video.getAttribute('loop') === '');
        const controls = (this.$video.getAttribute('controls') === '');
        const $playButton = this.$media.querySelector('[data-media="play"]');
        const $pauseButton = this.$media.querySelector('[data-media="pause"]');

        if (autoplay) {
            this.$media.classList.add('is--playing');
            this.$video.load();
        }

        if (!loop) {
            this.$video.addEventListener('ended', () => {
                this.$media.classList.remove('is--playing');

                if (!controls) {
                    showPlayButton();
                }
            });
        }

        if ($playButton) {
            $playButton.addEventListener('click', () => {
                this.$media.classList.add('is--playing');
                showPauseButton();
                this.$video.play();
            });

            $playButton.addEventListener('keydown', (e) => {
                if (e.code === 'Space') {
                    e.preventDefault();
                    this.$media.classList.add('is--playing');
                    showPauseButton();
                    this.$video.play();
                }
            });
        }

        if ($pauseButton) {
            $pauseButton.addEventListener('click', () => {
                this.$media.classList.remove('is--playing');
                showPlayButton();
                this.$video.pause();
            });

            $pauseButton.addEventListener('keydown', (e) => {
                if (e.code === 'Space') {
                    e.preventDefault();
                    this.$media.classList.remove('is--playing');
                    showPlayButton();
                    this.$video.pause();
                }
            });
        }

        const showPauseButton = () => {
            $playButton.setAttribute('aria-hidden', true);
            $playButton.removeAttribute('tabindex');
            $pauseButton.removeAttribute('aria-hidden');
            $pauseButton.setAttribute('tabindex', 0);
        };

        const showPlayButton = () => {
            $pauseButton.setAttribute('aria-hidden', true);
            $pauseButton.removeAttribute('tabindex');
            $playButton.removeAttribute('aria-hidden');
            $playButton.setAttribute('tabindex', 0);
        };
    }
}

export { MediaSelector };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const initMediaSelector = () => {
            const $$medias = $context.querySelectorAll('[data-media]');
            if ($$medias.length > 0) {
                for (let i = 0; i < $$medias.length; i++) {
                    const $media = $$medias[i];

                    const mediaAPI = new MediaSelector($media);
                    mediaAPI.initialize();
                }
            }
        };

        if (typeof window.YT === 'undefined') {
            console.log('YT not defined, wait for iframe api');
            loadYoutubeApi();

            window.onYouTubeIframeAPIReady = () => {
                console.log('api ready, init media');
                initMediaSelector();
            };
        } else {
            console.log('api already loaded, init media');
            initMediaSelector();
        }
    }
});
